export default {
  emailOrPhone: 'Email or Phone...',
  password: 'Password...',
  access: 'ACCESS',
  thatsGreat: 'That´s great',
  openNewAccount: 'Open a new account',
  recoverPassword: 'Recover password',
  wrongPassword: 'Wrong password...',
  passwordMustBe8Characters: 'Password must be 8 characters...',
  passwordRequired: 'Password is required...',
  wrongEmailOrPhone: 'Wrong email...',
  emailOrPhoneRequired: 'Email or phone is required...',
  wrongInput: 'Must enter a valid email o phone',
  welcomeTitle: 'Already have an account?',
  welcomeText: 'It´s great to have you back!',
  loginButton: 'Looks good. Let´s go!'
}
